const apiUrl = "https://inspector-api.services.teleporthq.io";
// const apiUrl = "http://localhost:3000";
var url = "";

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());
gtag("config", "UA-116252748-4");

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sParameterName,
    i;

  if (sPageURL) {
    var sURLVariables = sPageURL.split("&");
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
  } else {
    return "";
  }
};

function checkProtocol() {
  var protocol = url.split("://")[0];
  if (protocol != "http" && protocol != "https") url = "https://" + url;
}

function doRequest() {
  $("html, body").css("height", "100%");
  $(".sendBtn").attr("disabled", true);
  gtag("event", "inspect", {
    event_label: url,
  });
  $("#clipboardText").css("display", "none");

  target.value = "https://inspect.teleporthq.io/?url=" + url;

  $(".toolInfo").css("display", "none");
  $(".loading").css("display", "flex");
  $("#displayDiv").css("display", "none");
  $(".error").css("display", "none");
  $("#shareButton").css("display", "none");

  var request = new XMLHttpRequest();
  request.open("GET", `${apiUrl}/parse?url=${url}`, true);

  //inspector-api.services.teleporthq.io/results/inspector-Oxw5L3/depth_teleporthqio.png//
  https: request.onload = function () {
    const data = JSON.parse(request.responseText);
    if (request.status >= 200 && request.status < 400 && !data["error"]) {
      console.log(Date.now());
      insertImages(apiUrl, url, data);

      $("html, body").css("height", "");
      $(".sendBtn").attr("disabled", false);

      $(".loading").css("display", "none");
    } else {
      $(".sendBtn").attr("disabled", false);
      $(".loading").css("display", "none");
      $(".error").css("display", "flex");
    }
  };

  request.onerror = function () {
    $(".sendBtn").attr("disabled", false);
    $(".loading").css("display", "none");
    $(".error").css("display", "flex");
  };

  request.send();
}

function insertImages(apiUrl, url, data) {
  $("#displayDiv").css("display", "block");
  $(".img-grid").css("display", "block");
  $("#siteName").text(`Site Analysis for ${url}`);
  $("#shareButton").css("display", "block");
  $(".footer").css("position", "relative");

  const ids = [
    "screenshot",
    "design",
    "layoutDepth",
    "depth",
    "left",
    "width",
    "top",
    "height",
  ];

  function updateImageOnAvailable(id, retry) {
    if (retry === 10) return;

    var image_url = apiUrl + data[id];

    var image = new Image();

    image.onload = function () {
      // image exists and is loaded
      $(`#${id}`).attr("src", apiUrl + data[id]);
    };
    image.onerror = function () {
      // image did not load

      setTimeout(function () {
        updateImageOnAvailable(id, retry++);
      }, 1500);
    };

    image.src = image_url;
  }

  ids.forEach((id) => updateImageOnAvailable(id, 1));
}

function copyLinkToClipboard() {
  var copyText = document.querySelector("#_hiddenCopyText_");
  copyText.select();
  var succeed;
  try {
    succeed = document.execCommand("copy");
  } catch (e) {
    succeed = false;
  } finally {
    document.createElement("input");
  }
}

$(document).ready(function () {
  $("#inspectorForm").submit(function (event) {
    event.preventDefault();
    $(".input-url").blur();
    url = $("#inputUrl").val();

    checkProtocol();
    doRequest();
  });

  document.getElementById("shareButton").addEventListener("click", function () {
    copyLinkToClipboard();
    document.getElementById("clipboardText").value = document.getElementById(
      "_hiddenCopyText_"
    ).value;

    gtag("event", "share", {
      event_label: document.getElementById("clipboardText").value,
    });

    $("#clipboardText").css("display", "block");
    document.getElementById("copyToClipboardWarning").className = "slideIn";

    setTimeout(function () {
      document.getElementById("copyToClipboardWarning").className = "slideOut";
    }, 3000);
    $("#clipboardText").focus();
    document.querySelector("#clipboardText").select();
  });
});

url = getUrlParameter("url");
$(".input-url").focus();

var target = document.createElement("input");
var targetId = "_hiddenCopyText_";
target.style.position = "absolute";
target.style.left = "-99999px";
target.id = targetId;
document.body.appendChild(target);

if (url != "") {
  checkProtocol();
  target.value = "https://inspect.teleporthq.io/?url=" + url;

  $(".input-url").val(url);
  doRequest();
}

function imageExists(image_url, node) {
  var http = new XMLHttpRequest();

  http.open("HEAD", image_url, false);
  http.send();

  return http.status !== 404;
}
